import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class MailService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.MAILS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.MAILS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.MAILS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.MAILS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.MAILS(id), data);
    }
}
